import { useField } from 'formik'
import Styles from './GeneratedArchetypePreview.module.scss'
import { GeneratedArchetypePreviewProps } from './Types'
import { useEffect } from 'react'
import { useGenerateDesignContentSync } from 'hooks/queries/workspaces/useGenerateDesignContentSync'
import { LoadingShimmerer } from 'components/LoadingShimmerer/LoadingShimmerer'
import { DesignContentPreview } from 'components/DesignContentPreview/DesignContentPreview'
import { observer } from 'mobx-react-lite'

const GeneratedArchetypePreview = observer(({ archetype, isSelected }: GeneratedArchetypePreviewProps) => {
  const [{ value: topic }] = useField('topic')
  const [{ value: language }] = useField('language')
  const [{ value: brand_voice_id }] = useField('brand_voice_id')
  const [{ value: tone }] = useField('tone')
  const [{ value: brand_kit_id }] = useField('brand_kit_id')
  const [{ value: brand_visual_kit_id }] = useField('brand_visual_kit_id')
  const [{ value: initial_media_file_remove_background }] = useField('initial_media_file_remove_background')
  const [{ value: initial_media_file_id }] = useField('initial_media_file_id')
  const [{ value: width }] = useField('width')
  const [{ value: height }] = useField('height')
  const [, , { setValue: setContent }] = useField('content')
  const generateMutation = useGenerateDesignContentSync({ retry: 3 })
  const toneDep = JSON.stringify(tone)

  useEffect(() => {
    const controller = new AbortController()

    generateMutation.mutate({
      topic,
      language,
      brand_voice_id,
      tone,
      brand_kit_id,
      brand_visual_kit_id,
      initial_media_file_id,
      initial_media_file_remove_background,
      apply_brand: true,
      signal: controller.signal,
      archetype,
      width,
      height,
    })

    return () => {
      controller.abort()
    }
  }, [archetype, topic, language, brand_voice_id, toneDep, brand_kit_id]) // eslint-disable-line react-hooks/exhaustive-deps

  const request = generateMutation.data
  const generatedContent = request?.generated_content

  useEffect(() => {
    if (isSelected && generatedContent) {
      setContent(JSON.parse(generatedContent))
    }
  }, [generatedContent, isSelected]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={Styles.root}>
      <LoadingShimmerer className={Styles.designPreview} show={generateMutation.isLoading} borderRadius={0}>
        {generatedContent && (
          <div className={Styles.designPreview} data-testid="archetype-preview">
            <DesignContentPreview content={JSON.parse(generatedContent)} />
          </div>
        )}
      </LoadingShimmerer>
    </div>
  )
})

export { GeneratedArchetypePreview }
